var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from './baseApi';
import { adaptListParams } from '../utils';
export default class FieldSchemaApi extends BaseApi {
    constructor(apiCall, presetsApi) {
        super(apiCall);
        this.apiCall = apiCall;
        this.presetsApi = presetsApi;
        this.apiBasePath = 'field-schema';
    }
    getSchema(id) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiBasePath}/${id}`,
        });
    }
    listSchemas(params = {}) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiBasePath}`,
            params: Object.assign({}, adaptListParams(params)),
        });
    }
    isMachineNameExist(machineName) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiBasePath}/machine-name-exist`,
            params: {
                machine_name: machineName,
            },
        });
    }
    lockFields(fields) {
        return this.apiCall({
            method: 'PATCH',
            route: `${this.apiBasePath}/readonly`,
            data: {
                readonly: true,
                fields,
            },
        });
    }
    unlockFields(fields) {
        return this.apiCall({
            method: 'PATCH',
            route: `${this.apiBasePath}/readonly`,
            data: {
                readonly: false,
                fields,
            },
        });
    }
    updateSchema(id, data) {
        return this.apiCall({
            method: 'PATCH',
            route: `${this.apiBasePath}/${id}`,
            data,
        });
    }
    deleteSchema(schemaIdentifier) {
        return this.apiCall({
            method: 'DELETE',
            route: `${this.apiBasePath}/${schemaIdentifier}`,
        });
    }
    createSchema(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = params;
            if (data.presetIds && !data.schemaPresets) {
                const { items } = yield this.presetsApi.listSchemaPresets({ ids: data.presetIds });
                data = Object.assign(Object.assign({}, data), { schemaPresets: items });
            }
            return this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
}
//# sourceMappingURL=fieldSchemaApi.js.map